import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P412List_A({ dataTable, setAction, setDis }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const actionBodyNew = () => setAction({ target: "413", action: "NEW", data: null });
    const actionBodyEdit = (rowData = null) => setAction({ target: "413", action: "EDIT", data: rowData });

    const headerLabel = <span className="hidden-responsive">เพิ่มเส้นทาง</span>;
    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive " icon="pi pi-plus" label={headerLabel} onClick={() => actionBodyNew()} disabled={setDis === "NEW" ? true : false} />
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    header={header}
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="routeNo" header="เส้นทาง" sortable body={(e) => normalColumn(e, "routeNo", "เส้นทาง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeName" header="สถานที่" body={(e) => normalColumn(e, "routeName", "สถานที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="pipeLength" header="ความยาวรวม (ม.)" body={(e) => normalColumn(e, "pipeLength", "ความยาวรวม (ม.)")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeAmount" header="มูลค่าเส้นทาง" body={(e) => normalColumn(e, "routeAmount", "มูลค่าเส้นทาง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routePlanNo" header="เลขที่แบบแปลน" body={(e) => normalColumn(e, "routePlanNo", "เลขที่แบบแปลน")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeUpdateUserName" header="ผู้แก้ไข" body={(e) => normalColumn(e, "routeUpdateUserName", "ผู้แก้ไข")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeUpdateDt" header="วันที่-เวลาแก้ไข" body={(e) => normalColumn(e, "routeUpdateDt", "วันที่-เวลาแก้ไข")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="แก้ไข" field="photoPath" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            {/* </div> */}
        </div>
    );
}
